import { render, staticRenderFns } from "./PopupDialog.vue?vue&type=template&id=64f6e19c&scoped=true&"
import script from "./PopupDialog.vue?vue&type=script&lang=js&"
export * from "./PopupDialog.vue?vue&type=script&lang=js&"
import style0 from "./PopupDialog.vue?vue&type=style&index=0&id=64f6e19c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64f6e19c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('64f6e19c')) {
      api.createRecord('64f6e19c', component.options)
    } else {
      api.reload('64f6e19c', component.options)
    }
    module.hot.accept("./PopupDialog.vue?vue&type=template&id=64f6e19c&scoped=true&", function () {
      api.rerender('64f6e19c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2HMtB83I6YR7n/JS/comp/PopupDialog.vue"
export default component.exports